import { formatDateString, formatDateTimeString } from '@/libs/logic';
import { number2ThousandsFormat } from '@/components/number-input/display-format';
import Decimal from 'decimal.js';

export const dateRender = (h, val) => {
    return h('div', [
        h('span', {}, formatDateString(val))
    ]);
};

export const dateTimeRender = (h, val) => {
    return h('div', [
        h('span', {}, formatDateTimeString(val))
    ]);
};

export const currencyRender = (h, val, fractional = 4, currencyPrefix = '￥') => {
    return h('div', [
        h('span', {}, number2ThousandsFormat(val, fractional, currencyPrefix))
    ]);
};

export const getNumberThousandString=function (num, delfaultValue='', dig=2){
    if(num){
        let numTwoDigit =num.toFixed(2);
        return parseFloat(numTwoDigit).toLocaleString("en", { minimumFractionDigits: dig });
    }
    else{
     
        return delfaultValue;
    }
};

//转换成小数位数向下取整，dig小数位数
export const getNumberFloorDecimal=function (num, dig=2){
    if(!num){
        return 0.00;
    }
    // console.log(num);
    // num=Number(num);
    // let num1=num.toFixed(2)
    // console.log(num1)
    // return num1;
    let decimalNumber = new Decimal(num);
    // 保留两位小数并向下取整
    return decimalNumber.toDecimalPlaces(dig, Decimal.ROUND_FLOOR).toNumber();
};


//转换成小数位四舍五入取整，dig小数位数
export const getNumberDecimalFixed=function (num, dig=2){
    if(!num){
        return 0.00;
    }
    let decimalNumber = new Decimal(num);
    // 保留两位小数并向下取整
    return decimalNumber.toFixed(dig);
};

//减法运算
export const numberSubtraction=function (num1, num2){
    if(!num1||isNaN(num1)){
        num1=0;
    }
    if(!num2||isNaN(num2)){
        num2=0;
    }
    num1=new Decimal(num1);
    num2=new Decimal(num2);
    // 保留两位小数并向下取整
    return num1.sub(num2).toNumber();
};


//减法运算
export const numberDecimalSub=function (num1, num2, dig=2){
    if(!num1||isNaN(num1)){
        num1=0;
    }
    if(!num2||isNaN(num2)){
        num2=0;
    }
    num1=new Decimal(num1);
    num2=new Decimal(num2);
    // 保留两位小数并向下取整
    return Number(num1.sub(num2).toFixed(dig));
};


//乘法运算
export const numberDecimalMul=function (num1, num2, dig=2){
    if(!num1||isNaN(num1)){
        num1=0;
    }
    if(!num2||isNaN(num2)){
        num2=0;
    }

    num1=new Decimal(num1);
    num2=new Decimal(num2);
   
    return Number(num1.mul(num2).toFixed(dig));
};


//乘法运算数组相乘
export const numberDecimalMulArr=function (arr, dig=2){
    let num1=new Decimal(1);

    for(let num of arr){
        if(!num||isNaN(num)){
            num=0;
        }
        num=new Decimal(num);

        num1=num1.mul(num);
    }
   
    return Number(num1.toFixed(dig));
};


//加法运算
export const numberDecimalAdd=function (num1, num2, dig=2){
    if(!num1||isNaN(num1)){
        num1=0;
    }
    if(!num2||isNaN(num2)){
        num2=0;
    }

    num1=new Decimal(num1);
    num2=new Decimal(num2);
   
    return Number(num1.add(num2).toFixed(dig));
};


//数组加法运算
export const numberDecimalAddArrary=function (arr, dig=2){


    let tatol=new Decimal(0);
    for(let num of arr){
        if(!num||isNaN(num)){
            num=0;
        }
        num=new Decimal(num);
        tatol=tatol.add(num);
    }

    return Number(tatol.toFixed(dig));
};


//除法运算
export const numberDecimalDIV=function (num1, num2, dig=2){
    if(!num1||isNaN(num1)){
        num1=0;
    }
    if(!num2||isNaN(num2)){
        num2=0;
    }

    num1=new Decimal(num1);
    num2=new Decimal(num2);
   
    return Number(num1.div(num2).toFixed(dig));
};